import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";

const styles = makeStyles({
  root: {
    "&.MuiInputBase-root": {
      border: "1px solid #e7e7ed",
      borderRadius: "4px",
      height: "40px",
      "& input": {
        textIndent: "0.4rem",
      },
      "& svg": {
        cursor: "pointer",
      },
    },
  },
  classSpan: {
    fontSize: "0.8rem",
    color: "#da1414",
  },
});
export default (props) => {
  const [visualizationPassword, setVisualizationPassword] = useState(false);
  const classes = styles();

  const toggleVisualizationPassword = () => {
    setVisualizationPassword(!visualizationPassword);
  };
  return (
    <div>
      <Tooltip title={props.tooltip || ""}>
        <Input
          className={classes.root}
          name={props.name}
          type={visualizationPassword ? "text" : "password"}
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
          endAdornment={
            <InputAdornment position="start">
              {visualizationPassword && (
                <VisibilityIcon onClick={toggleVisualizationPassword} />
              )}
              {!visualizationPassword && (
                <VisibilityOffIcon onClick={toggleVisualizationPassword} />
              )}
            </InputAdornment>
          }
          fullWidth={props.fullWidth}
          style={{ width: props.width || "auto" }}
        ></Input>
      </Tooltip>
      <span className={classes.classSpan}> {props.error}</span>
    </div>
  );
};
